var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tag",class:{sel: _vm.sel},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleEmitGallery($event)}}},[_vm._v(_vm._s(_vm.gallery.name))])}
var staticRenderFns = []

export { render, staticRenderFns }